export const UPDATE_SPELL_LIST = "UPDATE_SPELL_LIST";
export const UPDATE_FAVOURITES = "UPDATE_FAVOURITES";
